export default {
    //交易管理
    dealmanagement:{
        aftersalesManagement:{
            aftersalesManagement:'售后单管理',
            orderNo:'售后单号',
            associatedOrderNumber:'关联订单号',
            afterSingleType:"售后单类型",
            orderSourceList:"原订单来源",
            creationDate:"创建时间",
            skuCode:"商品编码",
            SkuName:"商品名称",
            refundStatus:"售后单状态",
            channelName:"门店名称",
            skuSeriaLno:"商品串码",
            storeOrderInformation:"门店售后单信息",
            relationOrderNo:'销售单号',
            orderSource:"订单来源",
            refundQty:"退换数量",
            refundMoney:"退款总金额",
            consumerName:"消费者姓名",
            consumerPhone:"消费者电话",
            retailerName:"零售商名称",
            createdBy:'创建人',
            afterOrderDetails:"售后单详情",

            afterOrderInformation:"售后单信息",
            ChannelCode:"门店编码",
            iretailCode:"门店iretail编码",
            retailerCode:"零售商编码",
            CustomerCode:"零售商PRM编码：",
            productInformation:"商品信息",
            onlinePayment:"线上支付",
            offlinePayment:"线下支付",
            lightWeightPlatform:"轻量化平台",
            smallProgram:"小程序",
            Unionpay:"银联",
            Alipay:"支付宝",
            wechat:"微信",
            cash:"现金",
            supplierShortName:"供应商",
            SerialNo:"串码",
            typeCode:"商品类型",
            virtualGoods:"虚拟商品",
            physicalGoods:"实物商品",
            codeAssociatedCommodity:"权益商品关联的串码",
            replacementQuantity:'退换货数量',
            refundMoneys:"退款金额",
            retailPrice:"建议零售价",
            salePrice:"零售价",
            totalLineAmount:"行总金额",
            lineDelivery:"行实收",
        },
        ordermonitor:{
            pushMonitoring:"订单推送监控",
            orderNumber:"订单号",
            shopGroup:"店铺组" ,
            shopName:"店铺名称",
            executionEvents:"执行事件",
            executionResults:"执行结果",
            storeCode:"店铺编码",
            lastExecutionTime:"最后执行时间",
            numberOfExecutions:"执行次数",
            executionNoEmpty:"执行事件不能为空",
            orderNoEmpty:"订单类型不能为空",
            executionsNoEmpty:"执行次数不能为空",
            executionsNotEmpty :"已执行次数不能为空",
            salesPushIdeal:"销售订单推送IDEAL",
            salesPushEFA:"销售订单推送EFA",
            modifyExecutions:"修改执行数",
            upperBody:"上级主体",
            channelCode:"店铺编码",
            limitCount:"执行次数",
            lastUpdateDate:"最后执行时间",
            orderDetails:"订单详情",
            monitoringConfiguration:"推送监控配置",
            orderType:"订单类型",
            shopPaymentOrder:"门店线下付款订单",
            vendorSalesOrder:"供应商销售订单",
            exchangeOrders:"换货订单",
            returnOrder:"退货订单",
            pushMonitoringInformation:"推送监控信息",
            manuallyModifyExecutions:"手动修改已执行数",
            pushMonitoringList:"推送监控列表",
            editExecutionCount:"编辑执行次数",
            newConfiguration:"新增配置",
            deleteConfigurationItem:"删除配置项"
        },
        retailordermanage:{
            orderNumber:"订单号",
            creationTime:"创建时间",
            paymentTime:"支付时间",
            orderType:"订单类型",
            orderSource:"订单来源",
            customNo:"自定义订单号",
            retailerName:"零售商名称",
            retailerCode:"零售商编码",
            consumerName:"消费者姓名",
            channelName:"门店名称",
            channelCode:"门店编码",
            channelIretailCode:"门店retail编码",
            consumerPhone:"消费者电话",
            createdBy:"创单人",
            salesName:"促销员",
            paymentType:"支付类型",
            paymentChannel:"支付方式",
            paymentDate:"支付时间",
            totalMoney:"订单总金额",
            discountMoney:"优惠总金额",
            paymentMoney:"支付金额",
            couponCode:"优惠券编码",
            couponMoney:"优惠券金额",
            currency:"币种",
            logisticsCompany:"物流公司",
            logisticsBillNo:"物流单号",
            consigneeName:"收件人",
            consigneePhone:"收件人电话",
            consigneeAddres:"收货地址",
            onlinePayment:"线上支付",
            offlinePayment:"线下支付",
            lightWeightPlatform:"轻量化平台",
            smallProgram:"小程序",
            Unionpay:"银联",
            Alipay:"支付宝",
            wechat:"微信",
            cash:"现金",
            skuName:"商品名称",
            skuCode:"商品编码",
            spuName:"SPU商品名称",
            spuCode:"SPU编码",
            typeCode:"商品类型",
            virtualGoods:"虚拟商品",
            physicalGoods:"实物商品",
            supplierShortName:"供应商",
            skuSerialNo:"串码",
            relationId:"使用权益的商品",
            refundQty:"已退数量",
            refundMoney:"退款金额",
            retailPrice:"建议零售价",
            salePrice:"零售价",
            buyQty:"商品数量",
            totalLineAmount:"行总金额",
            bankOffers:"行优惠",
            lineDelivery:"行实收",
            storeRetailManagement:"零售订单查询",
            retailOrderNumber:"零售订单号",
            productName:"商品名称",
            orderStatusList:"订单状态",
            paymentStatusList:"支付状态",
            createTime:"创建时间",
            startTime:"开始时间",
            endTime:"结束时间",
            payTime:"支付时间",
            moreQueryCriteria:"更多查询条件",
            refundStatusList:"退换货状态",
            isUseCoupon:"是否使用优惠券",
            skuSeriaL:"商品串码",
            consumerPhone:"消费者电话",
            orderNo:"零售单号",
            totalMoney:'订单总金额',
            discountMoney:'订单优惠金额',
            paymentMoney:'支付金额',
            paymentStatus:'支付状态',
            notPaid:"未支付",
            partialPayment:"部分支付",
            paymentSuccess:"支付成功",
            paymentException:"支付异常",
            orderStatus:'订单状态',
            pendingReview:"待审核",
            auditThrough:"审核通过",
            auditNotPass:"审核不通过",
            pendingDelivery:"待发货",
            partialShipment:'部分发货',
            alreadyShipped:"已发货",
            signed:"已签收",
            transactionCompletion:"交易完成",
            transactionCancellation:"交易取消",
            hasBeenCanceled:"已取消",
            refundStatus:'退换货状态',
            nonExchange:"未退换货",
            partialReturns:"部分退货",
            returnComplete:"退货完成",
            partialExchange:"部分换货",
            exchangeComplete:"换货完成",
            refundMoney:"退款金额",
            createdBy:"创建人",
            not:"否",
            yes:"是",
            retailerName:"零售商名称",
            listDetail:"订单详情",
            orderInformation:"订单信息",
            retailOrderInformation:"门店零售订单信息"
        },
        supplierorder:{
            vendorManagement:"供应商销售单管理",
            orderNo:"订单号",
            subjectName:"供应商名称",
            skuCode:"商品编码",
            createTime:"创建时间",
            startTime:'开始时间',
            endTime:'结束时间',
            skuName:"商品名称",
            retailerCode:"零售商编码",
            payTime:"支付时间",
            executeIdealResult:"推ideal状态",
            executeSupplierResult:"推供应商状态",
            orderStatusArray:"订单状态",
            paymentStatusArray:"支付状态",
            retailerName:"零售商名称",
            orderSourceNo:"采购单号",
            shippingInformationImport:"发货信息导入",
            uploadingFiles:"上传文件",
            signInformationImport:'签收信息导入',
            viewContract:"查看合同",
            orderDetails:"订单详情",
            totalMoney:"订单总金额",
            discountMoney:"优惠金额",
            paymentMoney:"实收金额",
            orderType:"订单类型",
            orderSource:"订单来源",
            logisticsCompany:"运单号",
            deliveryTime:"发货时间",
            receivTime:"签收时间",
            subjectNam:"供应商",
            salesContract:"销售合同",
            paymentType:"支付类型",
            paymentChannel:"支付方式",
            payMoney:"支付金额",
            priceConfirmed:"实库价保",
            delayIncentive:"临时激励",
            exceptionActivateList:"异常激活数据导入列表",
            activityInfoConfig:"活动信息配置",
            currency:"币种",
            invoiceType:"发票类型",
            titleType:"发票抬头类型",
            titleName:"发票抬头",
            taxpayerId:"纳税人识别号",
            logisticsCompanyNo:'物流公司',
            logisticsBillNo:"运单号",
            consigneeName:"收件人",
            consigneePhone:"收件人电话",
            consigneeAddress:"收货地址",
            skuName:'商品名称',
            skuCode:"商品编码",
            typeCode:"商品类型",
            supplierShortName:"供应商",
            salePrice:"售价",
            buyQty:"商品数量",
            totalLineMoney:"行总金额",
            signingTime:"签订时间",
            party:"甲方",
            contactName:"联系人",
            address:"地址",
            contactPhone:"电话",
            square:"乙方",
            agreement:"双方经友好协商，乙方向甲方采购以下产品",
            agreementOne:"一、供货的产品、数量及金额",
            settlementMethod:"结算方式",
            paymentMethod:"付款方式",
            countName:"户名",
            countBank:"开户银行",
            countNumber:"账号",
            platformSkuName:"产品",
            qty:"数量(台)",
            color:"颜色",
            unitPrice:"含税单价(元)",
            rowPrice:"总计金额(元)",
            auditInformation:'审核信息',
            logisticsCarrier:"物流承运商",
            orderInformation:"订单信息",
            paymentInformation:"支付信息",
            invoicingInformation:'开票信息',
            logisticsInformation:"物流信息"
        },
    },
    //财务管理
    finance:{
        basecfg:{
            invoiceConfiguration:"发票配置",
            operationSucceeded:"操作成功",
            classifyName:"优惠支付比例",
            single:"每单",
            status:"有效",
            classifyDesc:"财务模块类型",
            invoiceConfigurationInformation:"发票配置信息",
            propertyInformationTable:"属性配置信息表",
        },
        customerICBC:{
            ICBCAccount:"工行账户信息查询",
            refreshBalance:"刷新余额",
            details:"明细查询",
            recent:"最近",
            week:"一周",
            month:'一个月',
            year:'一年',
            monthChoose:"按月选择",
            orderPurchase:"下单采购",
            accountRecharge:"账户充值",
            accountList:"账户列表",
            tradingInformation:"交易信息列表",
        },
        fundAccountManage:{
            paymentAccountInformation:"第三方支付账户信息",
            bankAccount:"银行账户",
            receivingParty:"收款方",
            paymentParty:"付款方",
            yuanPercent:'元/单',
            organizationNoEmpty:"机构名称不能为空",
            accountNotEmpty:"账号不能为空",
            fundAccountList:"资金账户列表",
            incentiveBillingData:'激励结算数据',
            editAccountDetails:"编辑账户详情",
            tradingInformation:"交易信息",
            enable:"启用",
            disable:"禁用",
            transactions:"交易明细",
            accountType:"账户类别",
            accountInformation:"账户信息",
            interfaceInformation:"接口信息",
            rateInformation:"费率信息",
            contractInformation:"合同信息"
        },
        fundReport:{
            classificationDetails:"余额分类明细",
            priceGuarantee:"实库价保",
            temporaryIncentives:"临时激励",
            subAccount:"子账户",
            today:'今天',
            yesterday:"昨天",
            weekAgo:'一个星期前',
            weekNear:'最近一周',
            nearMonth:'最近一个月',
            nearYear:'最近一年',
            supplierShortName:"供应商",
            businessType:"业务类型",
            businessNo:"业务单号",
            changeTime:"发生日期",
            tempDiscount:'临时激励',
            bankBalance:"工行账号",
            fundBalance:"在账资金余额",
            balanceAccount:"在账资金余额查询",
            yearMonth:"年月",
            details:'在账资金明细表',
            near:'最近',
            week:'一周',
            month:'一个月',
            year:'一年',
            monthChoose:"按月选择",
            orderPurchase:'下单采购',
            accountRecharge:'账户充值',
            incentiveImport:"激励导入",
            chooseYearMonth:"选择年月",
            fundsBalancesAccount:"在账资金余额列表",
            listFundsBalances:'在账资金余额明细列表'
        },
        incentiveImport:{
            priceGuarantee:"实库价保",
            temporaryIncentives:"临时激励",
            incentiveImportList:"激励管理",
            importTemplateUpload:'激励导入模板上传',
            templateDownload:"模板下载",
            pendingReview:"待审核",
            auditThrough:"审核通过",
            auditNotPass:"审核不通过",
            operationHistory:'操作履历',
            operation:'履历',
            details:'详情',
            audit:'审核',
            importTracking:"导入单号",
            importSuccess:"导入成功",
            incentiveImport:"激励导入",
            auditOpinion:"审核意见" ,
        },
        bill:{
            supplierShortName:'发票主体',
            billType:'发票类型',
            defaultType:'默认类型',
            defaultRise:'默认抬头',
            classifyName:'优惠支付比例'
        },
        capital:{
            supplierShortName:'供应商简称',
            accountType:'账户类别',
            accountUnit:'开户单位',
            organization:'机构名称',
            bankName:'开户银行名称',
            accountNo:'账号',
            channelGroupCode:'所属店铺组编码',
            channelGroupName:'所属店铺组名称',
            payType:'付款方式',
            status:'状态',
            openDateString:'开户时间',
            usedFlag:'是否启用',
            partnerPid:'合作者身份',
            securityKey:'安全校验码',
            serviceChargeDuty:'手续费承担方',
            serviceChargeWay:'支付手续费方式',
            fixedCharge:'按固定费用',
            ratioCharge:'按比例收费',
            contract:'零售商采购合同名称',
            remark:'零售商采购合同备注',
            businessDirection:'业务方向',
        },
        retailer:{
            serialNo:'交易流水号',
            retailerId:'零售商ID',
            retailerName:'零售商名称',
            supplierId:'供应商ID',
            supplierShortName:'供应商简称',
            accountName:'账号户名',
            accountNo:'工行账号',
            bankNo:'开户银行行号',
            bankName:'开户银行名称',
            openDate:'开户日期',
            balance:'余额(元)',
            currtype:'币种',
            idtype:'证件类型',
            idNo:'证件号',
            relatedAccountNo:'关联主账号',
            relatedAccountName:'主账号户名',
            relatedBankNo:'主账号关联银行行号',
            relatedBankName:'主账号关联银行名称',
            firstBalance:'期初余额',
            changeBalance:'发生额',
            lastBalance:'期末余额',
            businessNo:'业务流水单号',
            relatedBusiness:'关联业务',
            rcAccountNo:'收款账号',
            rcAccountName:'收款账户名称',
            rcBankNo:'收款账号开户行行号',
            rcBankName:'收款账号开户行名称',
            changeTime:'发生时间',
            mobilePhone:'短信验证手机号',
            createdBy:'创建人',
            creationDate:'创建时间',
        },
        discount:{
            impNo:'导入单号',
            fileName:'文件名称',
            calculateTime:'审核完成时间',
            closeTimeDate:'结算时间',
            loseTimeDate:'失效日期',
            impTime:'导入时间',
            impOperator:'导入人',
            approvaler:'审批人',
            remark:'备注(审批意见)',
            approvalStatus:'审批状态',
            disNo:'激励单号',
            disIndex:'激励序号',
            disType:'激励类型',
            customerId:'客户ID',
            contract:'合同号',
            channelName:'店铺名称',
            deptname:'部门',
            retailerId:'零售商ID',
            retailerCode:'零售商编码',
            retailerName:'零售商名称',
            spuModel:'产品型号',
            skuName:'产品名称',
            skuCode:'SKU编码',
            unitPrice:'单台激励',
            qty:'激励数量',
            totalPrice:'激励金额',
            avlBalance:'可用金额',
            supplierId:'供应商ID',
            supplierShortName:'供应商简称',
            operations:'操作',
            createdBy:'创建人',
            creationDate:'操作时间',
            results:'结果'
        },
        fund:{
            retailerId:'零售商ID',
            retailerName:'零售商名称',
            fundType:'资金类型',
            firstBalance:'期初余额',
            inBalance:'收入',
            outBalance:'支出',
            lastBalance:'期末余额',
            supplierId:'供应商ID',
            supplierShortName:'供应商简称',
            supplier:'供应商',
            yearMonth:'年月',
            businessType:'业务类型',
            businessId:'业务单ID',
            businessNo:'业务单号',
            changeTime:'发生时间',
            startDate:'开始时间',
            endDate:'结束时间',
            changeMoney:'发生金额',
            protectPrice:'实库价保',
            tempDiscount:'临时激励',
            bankBalance:'工行系统余额',
            fundBalance:'在账资金余额',
            tolProtectPrice:'最新实库价保总额',
            tolTempDiscount:'最新临时激励总额'
        },
        fundDetails:{
            bankBalance:'工行账户',
        } ,
        refund:{
            serialNo:'交易流水号',
            outTradeNo:'支付编号',
            afterSaleNo:'售后单编号',
            refundNo:'退款单号',
            totalFee:'订单支付总金额',
            refundFee:'退款金额',
            payType:'退款类型',
            payWay:'退款方式',
            payState:'退款状态',
            consumer:'消费者姓名',
            retailerName:'零售商名称',
            channelName:'店铺名称',
            orderSource:'订单来源',
            modifyState:'修改退款单状态',
            bigDecimalModificationNum:'记录版本号',
            createdBy:'创建人',
            creationDate:'创建时间',
            failReason:'失败原因',

            orderNo:'订单编号',
            orderType:'订单类型',
            customNo:'自定义单号',
            iretailCode:'门店iretail编码',
            retailerCode:'零售商编码',
            channelId:'店铺编码',
            salesName:'促销员姓名',
            consumerName:'消费者姓名',
            consumerPhone:'消费者电话',
            paymentType:'支付类型',
            paymentChannel:'支付渠道',
            totalMoney:'订单总金额',
            discountMoney:'优惠总金额',
            paymentMoney:'实付金额',
            currency:'核算币种',
            couponMoney:'优惠券面额',
            couponCode:'优惠券编码',
            logisticsCompany:'物流公司',
            logisticsBillNo:'物流单号',
            consigneeName:'收货人姓名',
            consigneePhone:'收货人电话',
            consigneeAddres:'收货地址',

            paymentDate:'支付时间',
            creationDate:'创建时间',
            skuCode:'商品编码',
            skuName:'商品名称',
            typeCode:'商品类型',
            supplierShortName:'供应商简称',
            skuSerialNo:'商品串码',
            relationId:'关联的权益商品',
            refundQty:'退货数量',
            refundMoney:'退款金额',
            retailPrice:'建议零售价',
            salePrice:'销售价',
            buyQty:'购买数量',
            totalMoney:'行总金额',
            discountMoney:'行优惠金额',
            paymentMoney:'行实付金额',

            //退款单页面
            refundBatchNo:'退款单号',
            saleOrderNo:'销售单号',
            afterSaleOrderNo:'售后单号',
            tradementNo:'交易流水号',
            refundAmount:'退款总金额',
            saleOrderSource:'订单来源',
            refundStatus:'退款状态',
            failCause:'失败原因',
            refundChannel:'支付方式',

        },
        refunde:{
            createdBy:'创单人',
            orderNo:'售后单号',
            afterSalesTypeList:'售后类型',
            orderStatusList:'订单状态',
            refundStatus:'退货状态',
            orderSourceList:'订单来源',

        },
        sale:{
            channelName:'店铺名称',
            orderNo:'售后单号',
            afterSalesType:'售后类型',
            skuCode:'商品编码',
            skuName:'商品名称',
            orderStatus:'订单状态',
            refundQty:'退换数量',
            orderSource:'订单来源',
            refundMoney:'退款金额',
            consumerName:'消费者姓名',
            consumerPhone:'消费者电话',
            createdBy:'创建人',
            creationDate:'创建时间',
            relationOrderNo:'销售单号',
            refundStatus:'退货状态',

        },
        invoice:{
            retailerCode:'零售商编码',
            retailerName:'零售商名称',
            billType:'发票类型',
            defaultType:'是否默认开票',
            invoiceTitleType:'发票抬头类型',
            invoiceTitle:'发票抬头',
            taxNum:'纳税识别号',
            registerAddress:'注册地址',
            registerPhone:'注册电话',
            openBank:'开户行名称',
            bankAccountNo:'银行账号',
            receiverName:'发票收件人',
            receiverAddress:'发票收件地址',
            receiverPhone:'收件人电话',
            lastUpdatedBy:'修改人',
            lastUpdateDate:'修改时间',
            consigneeNationCode:'收件国家编码',
            consigneeProvinceCode:'收件省份编码',
            consigneeCityCode:'收件城市编码',
            consigneeAreaCode:'收件地区编码'
        }
    },
    home:{
        msg:"欢迎使用荣耀轻量化平台作业中心",
        msgLog:'对不起，您无权限操作系统，请重新登录！',
        back:'秒后将自动退出',
        directBack:'直接退出'
    },
    //库存管理
    inventory:{
        inventoryManage:{
            inCode:"入库单号",
            inType:"入库单类型",
            inStatus:"入库单状态",
            subjectType:"主体类型",
            subjectName:"主体名称",
            supplierShortName:"供应商",
            retailerName:"零售商名称",
            channelName:'门店',
            warehouseName:"入库仓库名称",
            skuCode:"商品编码",
            skuName:"商品名称",
            inNum:"入库数量",
            actualInNum:"实际入库数量",
            orderNo:"来源单号",
            createdBy:"创建人",
            creationDate:"创建时间",
            operationTime:'操作时间',
            creationEndDate:'创建结束时间',

            outCode:"出库单号",
            outType:"出库单类型",
            outStatus:"出库单状态",
            numberConfirm:"出库数量",
            warehouseType:"仓库类型",

            transitNum:"采购在途数量",
            actualInvNum:"实际库存数量",
            reserveInvNum:"预留库存数量",
            availableInvNum:"可售库存数量",
            sellTransitNum:"销售在途数量",
            snFlag:'是否需要扫描检查',
            isActivate:'是否激活',
            activateTime:'激活时间',
            activateCountry:'激活国家',
            activateProvince:'激活省份',
            activateCity:'激活城市',

            inWarehouseTime:"入库时间",
            ifShowPhone:"是否演示机",
            serialNumber:"串码",
            statusCode:"串码状态",
            snapshotCode:"快照编号",
            snapshotStartTime:"快照开始时间",
            snapshotEndTime:"快照结束时间",
            channelName:'门店',
            //串码出入库记录
            inOrderNo:'入库单',
            outOrderNo:'出库单',
           //以上部分是原有的部分，以下是新配置
            inventoryInquiry:"库存查询",
            stockSnapshot:"库存快照查询",
            download:"下载",
            productCodeInformation:"商品串码信息",
            inventoryChanges:"库存变动",
            queryLibraryCode:"串码查询",
            serialOutRecords:"串码出入库记录",
            serialCodeInformation:"串码信息",
            snapshotInformation:"库存快照信息",
            CodeInformation:"库存串码信息",
            accessRecordInformation:'串码出入记录信息',
            creationStartDate:"快照时间"
        },
        storageManage:{
            warehousingManagement:"入库单查询",
            inboundDetails:"入库明细",
            inboundInformation:'入库信息'
        },
        warehouseManage:{
            outLibraryManagement:'出库单查询',
            outStockDetails:"出库明细",
            OutofInformation:"出库信息",
        },
        out:{
            warehouseName:"出库仓库名称"
        },
        inquire:{
            warehouseName:"仓库名称"
        },
        psi:{
            operationNumber:'操作编号',
            pushQuantity:'推送数量',
            pushState:'推送状态',
            timesRepeatedPush:'已重推次数',
            causeFailure:'失败原因',
            orderNumber:'订单编号',
            pushType:'类型',
            operatingTime:'操作时间',
            dataType:'数据类型',
            country:'国家',
            province:'省份',
            city:'城市',
            fromProvinceName:'发货省份',
            fromCityName:'发货城市',
            toProvinceName:'到货省份',
            toCityName:'到货城市',
            transTime:'发货日期',
            snCode:'SN编码',
            subordinateCusCode:'客户编码',
            subordinateCusName:'客户名称',
            cusProductModel:'客户产品型号',
            ftpCode:'接入码',
            purchasePrice:'ST价格',
            cusProductName:'客户产品SKU',
            soDate:'销售日期',
            sellingPrice:'销售价格',
            storeName:'门店名称',
            storeCode:'门店编码',
            reserve2:'政企标识',
            imei:'IMEI',
            invDate:'退货日期',
            inTime:'入库日期',
            activationCountry:'销售国家',
            activationProvince:'销售省份',
            activationCity:'销售城市',
            activationTime:'销售时间',
            salePrice:'销售价格',

        },
        others:{
            reserve1:'政企标识',     //销售出、退货、门店入库、门店库存
            transTime:'Dispatch时间',   //门店入库
            purchasePrice:'采购价格'
        }
    },
    //营销管理
    marketing:{
        activityManage:{
            chooseArea:"选择地区",
            activityName:"活动名称",
            limitAmount:"报名数量" ,
            noLimitStores:"无门店数量限制",
            limit:"限制",
            storeRegistration:"个门店报名",
            channelShareRate:"报名标准",
            storeBearsCoupons:"门店承担优惠券",
            RMB:"元(优惠券金额已实际发放数量为准)",
            selectProduct:'选择商品',
            registrationTime:"报名时间",
            activityStartTime:"活动时间",
            eventDescription:'活动说明',
            enterActivity:'请输入活动名称',
            enterActivityLimit:"请输入活动名称(30字符以内)",
            enterNumber:'请输入正整数(6位数以内)！',
            enterStoreProporition:'请输入店铺承担比例',
            withinNumber:'请输入0-100以内的数!',
            timeNoEmpety:"时间不能为空",
            doNot:"请不要输入特殊字符！(30字符以内)",
            enterPositiveInteger:"请输入正整数(10位数以内)！",
            entryActivityDescription:"请输入活动说明",
            pleaseSelectRegion:"请选择地区",
            enterLimit:"请输入(30位数以内)！",
            delete:"删除",
            viewRegion:"查看所地区",
            alreadyEnrolled:"已经报名",
            store:"家",
            productRange:'商品范围',
            allProducts:'全部商品',
            designatedProducts:"指定商品",
            merchantsCouponRatio:'商家承担优惠券比例',
            couponMoney:"优惠券金额",
            lastUpdateDate:"操作时间",
            auditFailure:"审核失败",
            parentSubjectName:"零售商/供应商",
            applyStatus:"审核状态",
            channelCode:'门店编码',
            channelName:'门店名称',
            provinceName:'省份',
            cityName:"城市",
            seeWhy:"查看原因",
            voucherStatus:"领券情况",
            auditThrough:"审核通过",
            activityHasEnded:"活动已结束",
            activityPaused:"活动已暂停",
            activitiesInProgress:"活动进行中",
            activityNotStarted:"活动未开始",
            unlimitedQuantity:"无限制数量",
            pendingReview:'待审核',
            listMarketingActivities:"活动管理",
            activityStatus:"活动状态",
            createActivity:"创建活动",
            registrationDetails:"报名详情",
            edit:"编辑",
            activityCode:'活动编码',
            showProvince:"报名省份",
            channelGrade:"报名数量",
            unlimitedRegistrationQuantity:"无限制报名数量",
            signUpBusiness:"报名商家",
            eventInformation:"营销活动列表",
        },
        coupon:{
            couponGroupCode:"优惠组编码",
            couponName:"优惠券名称",
            distributionPlatform:"发放平台",
            smallProgram:"小程序",
            importExcel:"导入EXCEL",
            addCoupon:"创建优惠券",
            activityCode:"活动编码",
            activityName:"活动名称",
            denomination:"面额",
            RMB:"元",
            limitAmount:"限制金额（元）",
            number:"数量",
            employingCounting:"领用数",
            useNumber:"使用数",
            invalidNumber:"作废数",
            useTime:"使用时间",
            shelfStatus:"上架状态",
            couponDenomination:"优惠券面额",
            amountLimit:"金额限制",
            couponNumber:"优惠券数量",
            storeRange:"门店范围",
            goodsRange:"商品范围",
            receiveTime:"领取时间",
            usedTime:"使用时间",
            limitReceivedTimes:"限领次数",
            allStores:"全部门店",
            registeredStores:"报名门店",
            designatedStores:"指定门店",
            allGoods:"全部商品",
            designatedGoods:"指定商品",
            storeCode:"门店编码",
            storeName:"门店名称",
            area:"地区",
            isShelves:'是否上架',
            goodsNameGoodscodeSupplier:"商品名称/编码/供应商",
            goodsCatgegory:"商品分类",
            goodsSKUCode:"商品SKU编码",
            goodsModel:"商品型号（SPU）",
            memory:"内存",
            reasonablePriceRange:"合理价格区间",
            editCoupon:"编辑优惠券",
            select:"选择",
            cancelSelect:"取消选择",
            discountGroupCode:"优惠组编码",
            getCoupon:"领券情况",
            couponCode:"优惠券编码",
            orderNumber:"订单号",
            consumptionTime:"消费时间",
            collarPersonnel:"领用人",
            salesNumber:"销售单号",
            consumerStores:"领用门店",
            storeCommitmentAmount:"门店承担金额",
            distributionStore:"发放商家",
            viewCoupons:"查看优惠券",
            full:'满',
            yuan:"元",
            isYuan:"元可用",
            importStore:"导入门店",
            total:"总共",
            home:"家",
            startReceiveDate:"领取时间",
            startUseDate:"使用时间",
            isSlef:"是否上架",
            choosePlatform:"选择发放平台！",
            enterCouponName:"请输入优惠券名称！",
            enterContent:"请输入中文、数字和英文！",
            enterCharactersLess:"请输入20个字符以内！",
            chooseStoreRange:"请选择门店范围！",
            chooseGoodsRange:"请选择商品范围！",
            pickupNotEmpty:"领取开始时间不能为空",
            useNotEmpety:"使用开始时间不能为空",
            delete:'删除',
            chooseGoods:'选择商品',
            selectStore:"选择门店",
            couponInformation:"优惠券信息",
            couponTemplateUpload:"领券情况导入模板上传",
            exportingSmallPrograms:"导出至小程序",
            Shelves:"上架",
            lowerShelf:"下架",
            makeShelves:"确认上架",
            makeLowerShelf:"确认下架",
            startUseDate:"使用开始时间",
            endDate:"使用结束时间",
            alreadyShelves:"已上架",
            alreadyLowerShelf:'已下架',
            enterCouponDenomination:"请输入优惠券面额",
            enterAmountLimit:"请输入金额限制",
            enterCouponNumber:"请输入优惠券数量",
            collectionNotEmpty:"领取结束时间不能为空",
            endTimeEmpery:"使用结束时间不能为空",
            pleaseLookForward:"敬请期待！",
            view:"查看",
            aduit:"审核",
            platformCoupons:"优惠券列表",
            storeCoupons:"店铺优惠券"
        }
    },
    member:{
        level:{
            limitFiles:"图片<=1M,1000*560像素支持jpg/png/jpeg格式！",
            GrowthValue:"应大于上一等级所需成长值！",
            limitBgFiles:"图片<=1M,95*28像素支持jpg/png/jpeg格式！",
        }
    },
    merchant:{//商户管理
        buss:{
            bussCode:'商圈编码',
            bussName:'商圈名称',
            bussLiable:'负责人',
            bussDistrict:'地址',
            bussCountryCode:'国家',
            bussProvinceCode:'省份',
            bussCityCode:'城市',
            bussZoneCode:'地区',
            bussAdress:'详细地址',
            bussType:'商圈类型',
            bussCount:'商圈门店数量',
            bussCapa:'商圈总容量',
            bussLevel:'商圈等级',
            bussLongitude:'商圈经度',
            bussLatitude:'商圈纬度',
            statusCode:'状态',
            createdBy:'创建人',
            creationDate:'创建时间',
            lastUpdatedBy:'操作人',
            lastUpdateDate:'操作时间',
            level:'级别',
            residentPopulation:'区常驻人口（万人）',
            bussForm:'商圈业态',
            popularityRankings:'知名度排名',
            //新增配置
            addressManagement:"地址管理",
            region:"区域",
            businessCircleManagement:"商圈管理",
            listBusinessDistricts:"商圈列表",
        },
        channel:{
            hours:"小时",
            automaticCancellationTime:"自动取消时间",
            basicInformation:"基本信息",
            terminalImageInformation:"终端形象信息",
            offlineStore:'线下门店',
            partnerThroughShop:'伙伴通店',
            supplyShop:'供应商店',
            proprietaryShop:'2C自营店',
            channelCode:'店铺编码',
            oldChannelCode:'老店铺编码',
            channelName:'店铺名称',
            channelShortName:'店铺简称',
            cooperationChannelType:'合作门店类型',
            iretailCode:'iRetail编码',
            accountUuid:'关联UP/W3账号',
            subjectId:'隶属零售商ID',
            subjectName:'隶属零售商名称',
            channelGradeCode:'店铺业态',
            channelSquare:'店铺总面积',
            channelLiable:'店铺负责人',
            channelPost:'岗位',
            channelLeaseBeginTime:'店铺租期开始时间',
            channelLeaseEndTime:'店铺租期结束时间',
            channelPhone:'联系人电话',
            channelStartTime:'营业开始时间',
            channelEndTime:'营业结束时间',
            channelTelephone:'店铺电话',
            channelBusinessDistrict:'所属商圈',
            channelBeginTime:'开业时间',
            channelAddress:'店铺地址',
            channelCountryCode:'国家',
            channelProvinceCode:'省份',
            channelCityCode:'城市',
            channelZoneCode:'地区',
            channelAddressDetail:'店铺详细地址',
            channelExpiryStartTime:'店铺有效期:',
            channelExpiryEndTime:'店铺有效期结束',
            channelCounterNum:'投入柜台数量',
            channelLampNum:'投入灯箱数量',
            channelPartsNum:'投入配件柜数量',
            channelCashierNum:'投入收银台数量',
            channelNegotiatingNum:'投入洽谈桌数量',
            channelBackgroundWallNum:'投入背景墙数量',
            channelCultureWallNum:'投入文化墙数量',
            channelGridNum:'投入铁艺网格数量',
            channelBoutiqueNum:'投入精品柜数量',
            channelContactScreenNum:'投入联屏数量',
            channelWindowTvNum:'投入橱窗电视数量',
            channelExamine:'审核状态',
            channelRemarks:'备注',
            channelEnableStatus:'启用状态',
            createdBy:'创建人',
            creationDate:'创建时间',
            lastUpdatedBy:'最后变更操作人',
            lastUpdateDate:'最后变更时间',
            rinanceId:'关联ID',
            consigneeName:'收货人',
            consigneePhone:'收货人电话',
            consigneeAddress:'收货地址',
            consigneeCountryCode:'收货店址-国家',
            consigneeProvinceCode:'收货店址-省',
            consigneeCityCode:'收货店址-市',
            consigneeDistrictCode:'收货店址-区',
            consigneeDetail:'收货详细地址',
            isDisplayMini:'是否显示到小程序',
            dimension:'纬度',
            longitude:'经度',
            financeId:'关联ID',
            billType:'发票类型',
            invoiceTitle:'发票抬头',
            taxNum:'纳税识别号',
            registerAddress:'注册地址',
            registerPhone:'注册电话',
            openBank:'银行卡开户行',
            bankAccount:'银行卡号',
            tradeConfig:'交易配置',
            operation:'操作',
            operateType:'操作类型',
            operationResume:'操作履历',
            permanent:'永久',
            channelType:'店铺类型',
            auditThrough:'审核通过',
            pendingReview:"待审核",
            auditNotPassed:'审核未通过',
            registeredAccount:'注册账号',
            VATFreeInvoice:"增值税普通发票",
            addSpecialInvoice:"增值说专用发票",
            generalInvoice:"电子增值税普通发票",
            paymentCollectionScenario:'收款场景',
            tradeImport:"订单提交后",
            tradeSuccess:"交易成功",
            goPay:"去支付",
            goStatu:"启用状态",
            PartnerNotEmpty:"合作门店类型不能为空",
            storeNotEmpty:"店铺名称不能为空",
            channelCodeNoE:"店铺编码不能为空",
            nameNotEmpety:"店铺简称不能为空",
            subjectNotEmpety:"隶属零售商名称不能为空",
            accountNotEty:"关联UP/W3账号不能为空",
            squareNotEmpety:"店铺总面积不能为空",
            storeBusinessEmpty:'店铺业态不能为空',
            GraderCode:"面积为正数",
            notEmpetyTime:"店铺租期开始时间不能为空",
            channelLiableNot:'店铺负责人不能为空',
            postNotEmpety:"岗位不能为空",
            startNotEmpety:"营业开始时间不能为空",
            phoneNotEmpety:'联系人电话不能为空',
            timeNotEmpety:"自动取消时间不能为空",
            storeExpirationEmpty:"店铺有效期开始时间不能为空",
            enterPhone:"请输入正确的收货人电话！",
            enterContactNumber:"请输入正确的联系人电话",
            addressNotEmpety:"店铺地址不能为空",
            beginNotEmpety:"开业时间时间不能为空",
            consigneeNameNot:"收货人不能为空",
            consigneePhoneNot:"收货人电话不能为空",
            addressNoEmpety:"店铺收货地址不能为空",
            tradeChooseConfig:"请选择交易配置信息",
            transactionConfigurationEmpty:'交易配置信息不能为空',
            edit:"编辑",
            operationHistory:"操作履历",
            auth:"审核",
            cancle:"取消",
            makeLock:"确认禁用",
            confirmEnable:"确认启用",
            alreadyEnable:"已启用",
            alreadyLock:"已禁用",
            editOfflineStore:"编辑线下门店",
            operateResume:"操作履历",
            auditOfflineStore:'审核线下门店',
            invoiceAddress:"发票地址",
            auditFailure:"审核失败",
            partnerPassShop:"伙伴通店",
            Home:"首页",
            merchantManagement:"商户管理",
            storeManagement:"店铺管理",
            pmembership:"隶属零售商/供应商",
            head:"负责人",
            headPhone:"负责人电话",
            validity:"有效期",
            accountBank:"开户行",
            account:"银行账号",
            enableStatus:"启用状态",
            forever:"永久",
            financialInformation:"财务信息",
            bankCardNumber:"银行卡号",
            auditOpinion:"审核意见" ,
            come:"至",
            newSupplyStore:"新增供应商店",
            editSupplyStore:"编辑供应商店",
            operateRetailer:"操作履历",
            latitudeLongitudeInformation:"经纬度信息",
            showSmallPrograms:'展示到小程序',
            TencentMap:"腾讯地图：",
            longitude:"经度：",
            latitude:"纬度：",
            queryByLatitude:'经纬度查询',
            storeInformation:'店铺信息',
            smallProgramShow:"小程序展示",
            paperGeneralInvoice:"纸质普通发票",
            paperSpecialInvoice:'纸质专用发票',
            electronicTextInvoice :"电子普通发票",
            notOpenInvoice :'不开发票',
        },
        contract:{
            contractCode:"合同编码",
            retailerName:"零售商名称",
            retailerAccountNumber:" 零售商账号",
            signatory:"签署人",
            supplierName:"供应商名称",
            signingTime:"签署时间",
            contractInformation:"合同信息",
            signerEmail:"签署人邮箱",
            contracContent:"合同内容",
            supplierAccountNumber:"供应商账号"
        },
        supplier:{
            supplierCode:'供应商编码',
            supplierName:'供应商名称',
            accountBank:'开户行',
            bankAccount:'银行账号',
            newSupplier:'新增供应商',
            editSupplier:'编辑供应商',
            supplierShortName:'供应商简称',
            supplierAddress:'供应商地址',
            supplierPhone:'供应商电话',
            receiveInformation:'收货信息',
            consignor:'发货人',
            shipperPhone:'发货人电话',
            headPhone:'负责人电话',
            shipperAddress:'发货地址',
            bankNumber:'开户行号',
            supplierType:'供应商类型',
            isEnabled:'是否启用',
            authorizationCompany:'授权认证公司',
            sponsor:'发起人',
            honorSponsor:'荣耀发起人',
            submitter:'提交人',
            submitTime:'提交时间',
            statusCode:'授权书审核状态',
            initiatingAuthorizationCertification:'发起授权认证',
            authorizationCode:'授权编码',
            updateFileName:'供应商授权文件',
            gatewayProtocol:'网签协议',
            submitterDate:'发起时间',
            authorizeCertificationSupplier:'需授权认证供应商',
            authorizedProxy:'授权委托书',
            return:'返回',
            initiatingCertification:'发起认证',
            uploadDelegationAuthority:'上传委托授权书',
            viewDetails:'查看详情',
            suppliersOrRetailers:'供应商/零售商',
            auditHistory:'审核历史',
            auditAuthorization:'审核授权书',
            authorizedCertification:'授权认证管理',
            honorReviewers:'荣耀审核人',
            auditTime:'审核时间',
            uploadProxy:'上传委托书',
            downloadAuthorizationBook:'下载授权书',
            uploadAuthorizationBook:'上传授权书',
            uploadProtocol:'上传协议',
            uploadNetworkProtocol:'上传网签协议',
            otherInformation:"其他信息",
            validity:"有效期",
            shippingAddress:"收货地址",
            bankName:"账号名称",
            resumeInformationList:'履历信息列表',
            supplierInformation:"供应商信息",
            limitFiles:"限定2M以内,可上传gif、jpg、jpep、png文件。",
            certificationDetails:"认证详情"
        },
        file:{
            uploadFileName:'文件',
            uploadFileType:'文件类型',
            uploadDown:'上传/下载',
            operationPage:'操作页面',
            createdBy:'创建人',
            creationDate:'创建时间',
            fileHistory:"文件履历查询",
            resumeList:'履历列表',
        },
        retailerManage:{
            retailerAccount:"零售商账号",//zeng
            retailerCode:"老零售商编码",
            retailerName:"零售商名称",
            contact:"联系人",
            regional:"收货地区",
            associationUPW3Number:"关联UP/W3号",
            authenticationStatus:"认证状态",
            newRetailer:"新增零售商",
            updateRetailer:"编辑零售商",
            operateRetailer:"操作履历",
            exportExcel:"导出EXCEL",
            typeOfRetailer:"零售商类型",
            country:"收货国家",
            provinces:"收货省份",
            city:"收货城市",
            enableStatus:"启用状态",
            operationPerson:"操作人",
            whetherHonorKA:"是否荣耀KA",
            totalMonthlySales:"总体月销量",
            honorMonthSales:"荣耀月销量",
            contactTitle:"联系人职务",
            localRankings:"当地排名",
            contactAddress:"联系地址",
            destinationStoreAddress:"目标门店地址",
            storesNumber:"经营门店数量",
            honorCounterNumber:"荣耀专区专柜数量",
            brandLicensingShop:"经营品牌授权体验店",
            targetBusinessCircle:"目标商圈名称",
            brandExperienceShop:"商圈已有品牌授权体验店",
            businessLicensed:"上传营业执照",
            businessLicense:"申请模板",
            qualificationInformation:"资质信息",
            basicInformation:"基本信息",
            registeredCapital:"注册资本(万元)",
            storeNumber:"门店数量",
            monthlyCapacity:"月容量",
            consigneeName:"收货人姓名",
            consigneeTelephone:"收货人电话",
            retailerDeliveryAddress:"零售商收货地址",
            licensingInformation:"授权信息",
            businessLicenseName:"营业执照名称",
            legalRepresentativeID:"法人身份证",
            businessLicenseCode:"营业执照编码",
            taxpayerType:"纳税人类别",
            taxpayerProof:"纳税人证明",
            accountAuthorization:"账号授权书",
            customerApplicationForm:"神州数码客户申请表",
            financialInformation:"财务信息",
            invoiceType:"发票类型",
            VATTextInvoice:"增值税普通发票",
            VATSpecialInvoices:"增值税专用发票",
            eVATFreetextInvoice:"电子增值税普通发票",
            invoiceHeader:"发票抬头",
            taxIdentificationNumber:"纳税识别号",
            registeredAddress:"注册地址",
            registrationTelephone:"注册电话",
            bankCardAccount:"银行卡开户行",
            bankCardNumber:"银行卡号",
            auditOpinionArea:"审核意见",
            customerClassification:"区域客户分类",
            regionalResponsible:"区域负责人",
            retailerBusinessMode:"零售商业态",
            retailerOperatorAttribute:"运营商属性",
            retailerAbbreviation:"零售商简称",
            retailerLevel:"零售商等级",
            feneralTaxpayer:"一般纳税人",
            smallScaleTaxpayer:"小规模纳税人",
            retailerQualificationAudit:"零售商资质审核",
            qualificationAudit:"资质审核",
            retailerCertificationAudit:"零售商认证审核",
            AuditResults:"审核结果",
            auditPassed:"审核通过",
            honorRetailerCertification:"零售商认证审核（荣耀）",
            digitalRetailerCertification:"零售商认证审核 (神码)",
            auditNotPassed:"审核未通过",
            auditCertificationHistory:"审核认证历史",
            processingLinks:"处理环节",
            processingStatus:"处理状态",
            handlingPeople:"处理人",
            processingTime:"处理时间",
            supplementaryInformation:"补充信息",
            uploadingDocuments:"上传文档",
            uploadingImages:"上传图片",
            approvalLinkCode:"审核环节",
            customerNumber:"神码客户号",
            retailerCodes:"零售商代码",
            requestTemplateDownload:"申请模板下载",
            accountAuthorizationDownload:"账号授权认证委托书模板下载",
            applicationFormDownload:"申请表模板下载",
            entryApplicationName:"请输入零售商名称！",
            placeRequire:"请输入中文、数字和英文！",
            enterEnglish:"请输入中英文！",
            enterRegisteredCapital:"请输入注册资本！",
            enterPositiveInteger:"请输入正整数！",
            enterPhone:"请输入联系电话！",
            enterContactNumber:"请输入正确的联系电话！",
            enterStoreNumber:'请输入门店数量！',
            enterConsigneeName:"请输入收货人姓名！",
            enterMonthlyCapacity:"请输入月容量！",
            enterConsigneePhone:"请输入收货人电话！",
            enterConsigneeTel:"请输入正确的收货人电话！",
            retailNotEmpety:'零售商收货地址不能为空！',
            enterLicenseName:'请输入营业执照名称！',
            enterIDNO:'请输入法人身份证！',
            enterID:"请输入18位身份证号码！",
            enterLicenseCode:"请输入营业执照编码！",
            enterTaxpayerCategory:"请选择纳税人类别！",
            licenseNotEmpety:"营业执照不能为空！",
            taxpayerNotEmpety:"纳税人证明不能为空！",
            accountNotEmpety:"账号授权书不能为空！",
            tableNotEmpety:"神州数码客户申请表不能为空！",
            materialAudits:"材料审核",
            siteSurvey:"现场勘察",
            regionalPreliminaryExamination:"区域初审",
            headquartersReview:"总部复审",
            channelCustomerCode:'客户编码',
            limitUpload:"限定5M以内,可上传doc、docx文件。",
            limitClassfiy:"最多可上传20张,图片≤2M,支持pdf、jpg、png文件",
            console:"台",
            name:"名",
            retailerInformation:"零售商信息",
            License:'营业执照',
            personal:"个人",
            enterprise:"企业",
            depositaryBankName:"开户行名称",
            invoiceRecipient:"发票收件人",
            recipientAddress:"收件人地址"
        },
        supplied:{
            subjectName:'隶属供应商名称',
            updateFileName:"授权委托书",
            uploadAttorney:"上传委托书",
            aduitFailured:'审核失败(重新上传委托书)',
            rendingUploadProtocol:"待上传协议",
            Description:'说明',
            oneRules:"1、由荣耀上传授权认证书，并指定供应商发起授权认证。",
            twoRules:" 2、指定供应商下载授权认证书，完善内容并加盖公章后，重新上传等待荣耀审核。",
            thirdRules:"3、荣耀审核供应商上传的授权认证书，通过后等待供应商上传网签协议。",
            fourRules:"4、供应商上传网签协议后，则协议达成。",
            allMsg:'请完善信息并盖公章后上传',
        },
    },
    operate:{
        mealOperate:{
            mealType:"套餐类型",
            commodityModel:"主商品型号",
            source:"来源",
            groupName:"店铺组名称",
            combinationRuleName:"套餐类型名称",
            combinationRetailPrice:"套餐零售价",
            saleableNum:'套餐可售库存',
            skuCode:"商品编码",
            isMainSku:"是否主副商品",
            skuName:"商品名称",
            color:"颜色",
            defaultDelivery:"默认发货配件",
            memory:"内存",
            networkType:"网络类型",
            skuRetailPrice:"建议零售价",
            skuCombinationRule:"商品套餐价",
            qty:"数量",
            supplierName:"供应商",
            spuName:"商品型号",
            MainSku:'主副商品',
            packageManagement:'套餐管理',
            mealCode:"套餐编码",
            mealName:"套餐名称",
            skuMainCode:"主商品SKU编码",
            skuMainName:"主商品SKU名称",
            state:"状态",
            retailPrice:"套餐价格",
            lastUpdatedBy:"修改人",
            lastUpdateDate:"修改时间",
            remark:"备注",
            newPackage:"新增套餐",
            modifyPackage:"修改套餐",
            packageDetails:"套餐详情",
            addModify:"确认套餐",
            combinationName:"门店套餐名称",
            packageInformation:"套餐信息",
        },
        mealtype:{
            mealtype:"套餐类型",
            mainProductModel:"主商品型号",
            from:"来源",
            shopGroupName:"店铺组名称",
            updateBy:"修改人",
            updateTime:"修改时间",
            remark:"备注",
            create:"套餐类型创建",
            productModel:"商品型号",
            topCategory: "一级分类",
            secondCategory:"二级分类",
            thirdCategory:"三级分类",
            mainAndViceGoods:"主副商品",
            addProduct:"添加商品",
            deleteProduct:"删除商品",
            productInformation:"商品信息",
            packageTypeInformation:"套餐类型信息",
        }
    },
    operations:{
        commodityManage: "增值服务商品管理",
        create: "创建",
        skuGoodsCode:"SKU商品编码",
        skuGoodsName:"SKU商品名称",
        commodityCode: "增值服务商品编码",
        isMaintained:"是否已维护",
        commodityProduct: "增值服务商品",
        addedService:{
            selectSKUItems:"选择SKU商品",
        },
        advertising:{
            name:"名称" ,
            place:"位置",
            remark:"备注信息",
            url:"跳转地址",
            imgSrc:"图片",
            htmlStr:"转跳页面",
            fundAccountList:"资金账户列表",
            edit:"编辑",
            linkAddress:"链接地址",
            add:"新增",
            listAdvertisingOperations:"广告位管理",
        },
        commodity:{
            editGoods:"编辑商品SKU",
            upperShelf:"上下架",
            spuCodeL:"系列商品编码",
            spuName:"商品名称",
            productDetails:"商品详情",
            specificationParameter:"规格参数",
            packagingAfterSale:"包装售后",
            PC:"PC版",
            mobileVersion:"移动版",
            color:"颜色",
            uploadProductImage:"上传商品图片",
            retailPrice:"指导价",
            priceScope:"商品定价范围",
            skuShowName:"商品显示名称",
            merchandising:"商品促销语",
            saleableQuantity:"商品可售库存",
            salePrice:"售价",
            statusCode:"状态",
            SPUOperationInformation:"SPU商品营运信息",

        },
        notice:{
            noticeCode:"公告编号",
            noticeTitle:"公告标题",
            noticeContent:"公告内容",
            effectiveTime:"生效时间",
            effectiveStartTime:"生效开始时间",
            effectiveEndTime:"生效结束时间",
            effectiveStores:"生效门店",
            effectiveRange:"生效范围",
            announcementManagementInformation:"公告管理列表",
        }
    },
    commodity:{
        platform:{
            auth:"商品授权",
            audit:"商品审核",
            auditStatus:"审核状态",
            add:"平台商品创建",
            edit:"平台商品修改",
            storesAdd:"门店商品创建",
            storesEdit:"门店商品修改",
            name:"商品名称",
            supplier:"供应商",
            skuCode:"SKU编码",
            spuCode:"SPU编码",
            pushSupplierStatus:"推送供应商状态",
            levelA:"一级分类",
            levelB:"二级分类",
            levelC:"三级分类",
            type:"商品类型",
            IsSanagement:"是否串码管理",
            source:"商品来源",
            spuName:"SPU商品名称",
            image:"商品图片",
            retailPrice:"建议零售价",
            maxRetailPrice:"售价上限",
            minRetailPrice:"售价下限",
            color:"颜色",
            shopName:"店铺名称",
            shopGroupName:"店铺组名称",
            resume:"履历",
            supplyResults:"物料编码推供应商结果",
            supplyCode:"供应商物料编码",
            erpCode:"维护ERP编码"
        }
    },
    //采购管理
    purchasing:{
        detailedInfo:{
            export:"导出",
            applicationNumber:"申请单号",
            skuCode:"商品编码",
            platformSkuName:"商品名称",
            unitPrice:"供货价",
            applyQty:"申请数量" ,
            approvalQty:"审核数量",
            Suppliers:"供应商",
            orderDetailedInformation:"要货单详细信息",
        },
        goodsCheck:{
            orderApproval:"进货申请审核",
            applicationNumber:"申请单号",
            retailerName:"零售商名称",
            processingLinks:"处理环节",
            processingStatus:"处理状态",
            creatTime:"创建时间",
            startTime:"开始时间",
            endTime:"结束时间",
            purchaseRequisition:"零售商进货申请",
            storeApplication:"门店进货申请",
            applyName:"申请主体",
            applyNameCode:"申请主体编码",
            applyType:'申请类型',
            createdBy:"创建人",
            detailedInfo:"单号详细信息",
            toExamine:'进货申请单',
            operationResume:"操作履历",
            pendingReview:"待审核",
            pendingConfirmation:"待确认",
            auditInformation:'审核信息',
        },
        operationResume:{
            creationDate:"操作时间" ,
            operateDesc:'操作',
            lastUpdatedBy:"操作人"
        },
        toExamine:{
            auditOpinion:"审核意见" ,
            auditPass:"审核通过",
            auditFail:"审核不通过",
            noteMsg:"备注信息",
            applicationNumber:"申请单号",
            skuCode:"商品编码",
            platformSkuName:"商品名称",
            unitPrice:"供货价",
            applyQty:"申请数量" ,
            approvalQty:"审核数量",
            Suppliers:"供应商",
            combinationCode:'套餐编码',
            applicationSuccess:"申请单审核成功！",
            pleaseReconfirm:"审核数量全部为0，请重新确认！",
            auditNotEmpety:"审核不通过原因不能为空！"
        }
    },
    //系统管理
    systems:{
        myImportExport:{
            reportName:" 报表名称",
            exportFileName:"导出文件名",
            templateName:"模板名称",
            noReportEmpety:"报表名称不能为空",
            noFileEmpety:"导出文件名不能为空",
            noTemplateEmptey:"模板名称不能为空",
            importRules:"导入规则",
            importTemplate:"导入模板",
            checksumFailureCallback:"校验失败回调",
            ruleNoEmpety:"导入规则不能为空",
            importNoEmpety:"导入模板不能为空",
            checkCallback:"校验失败回调不能为空",
            dataCfg:"数据配置",
            delete:"删除",
            fileDownload:"文件下载",
            createCfg:"创建导出配置",
            modifyExportCfg:"修改导出配置",
            exportDataList:"导出数据列表",
            dataService:"数据服务",
            nameTemplateParameter:"模板参数名",
            status:"状态",
            taskId:"任务ID",
            flie:"文件名",
            exportMessage:"导出消息",
            importMessage:"导入消息",
            startTime:"开始时间",
            endTime:"结束时间",
            importTemplateUp:"导入模板上传",
            createImportCfg:"创建导入配置",
            modifyImportCfg:"修改导入配置",
            importServiceCfg:"导入服务配置",
            importFlie:"导入文件",
            timeout:"超时(毫秒)",
            maximumNumberRecords:"最大记录数",
            exportConfigurationList:"导出配置列表",
            exportInformation:'导出信息',
            flieName:"文件名称",
            exportDate:"导出日期",
            importInformation:'导入信息',
        },
        time:{
            group:'任务组',
            name:'任务名称',
            cron:'时间表达式',
            status:'状态',
            msg:'备注',
            requestUrl:'微服务URL',
            createTime:'创建时间',
            createby:'创建人',
            updateTime:'更新时间',
            updateby:'更新人',
            addClassList:"添加类列表",
            taskLogQuery:"任务日志查询",
            startTime:"开始时间",
            endTime:"结束时间",
            chooseTime:"请选择时间",
            failure:"失败",
            success:"成功",
            taskConfiguration:"任务配置",
            modifyingTaskList:"修改任务列表",
            addTaskList:"添加任务列表",
            taskNoEmpety:"任务组不能为空",
            taskNameEmpety:"任务名称不能为空",
            serviceNoEmpety:"微服务URL不能为空",
            statusNoEmpety:"状态不能为空",
            test:"测试",
            modify:"修改",
            delete:"删除",
            pause:"暂停",
            run:"运行",
            makePause:"确认暂停?",
            makeRun:"确认运行?",
            cancel:"取消",
            taskList:"任务列表",
            taskInformation:"任务信息",
            classifyName:"任务类名",
            anExpression:"表达式",
            news:"消息"
        },
        log:{
            group:'任务组',
            name:'任务名称',
            startTime:'开始时间',
            endTime:'结束时间',
            requestUrl:'微服务URL',
            requestTime:'请求时间',
            responseTime:'响应时间',
            responseStatus:'响应状态码',
            responseBody:'响应内容',
            errorMsg:'错误信息',
            creationDate:'创建时间',
            status:'状态'
        },
        international:{
           key1:"键",
           content:"内容",
           languages:'语种',
           note:"备注",
           simplified:"简体",
           English:"英文",
           Traditional:"繁体",
           createTime:"创建时间",
           updatedDate:"最后更新时间",
           total:"总共",
           reviews:"条",
           gridSelf:"Grid个性化设置",
           gridParams:"Grid参数设置",
           tips:"提示",
           noHidden:'带“*”号的列不能隐藏!',
           keyValue:"键<br>值"

        },
        lookup:{
            categoryEncoding:"类别编码",
            categoryName:"类别名称",
            addClassList:"添加类列表",
            classEncoding:"类编码",
            className:"类名称",
            status:"状态",
            categoryNote:"类别备注",
            categoryNoEmpety:"类编码不能为空",
            nameNoEmpety:"类名称不能为空",
            classNoEmpety:"类不能为空",
            lastUpdateDate:"最后更新时间",
            itemList:"项列表",
            classInformation:"类信息",
            classList:"类列表",
        },
        lookupItem:{
          lookUpClass:"LOOKUP查看类",
          lookUpResult:"LOOKUP项查询结果",
          itemEncoding:"项编码",
          itemDisplayName:"项显示名称",
          note:'备注',
          status:"启用",
          sort:"排序"

        },
        mouldConfig:{
            requestTemplate:"申请模板",
            accountAuthorizationTemplate:"账号授权认证委托书模板",
            customerApplicationTemplate:"客户申请表模板",
            inventoryImport:"库存导入",
            serialCodeImport:"串码导入",
            storeImport:"店铺导入",
            retailerImport:"零售商导入"
        },
        small:{
            appName:'系统名',
            groupName:'模块名',
            url:'服务URL',
            remark:'备注',
            createdBy:'创建人',
            creationDate:'创建时间',
            lastUpdatedBy:'最后更新人',
            lastUpdateDate:'最后更新时间',
            authenticationAddressManagement:"鉴权地址管理",
            serviceAddressList:"服务开放地址列表",
            modify:"修改",
            add:"添加",
            serviceAddressManagement:"服务开放地址管理",
        }
    },
    menus:{
        head:{
            configureSystem:"配置系统",
            authManage:"权限系统",
            merchantManage:"商户系统",
            inventoryManagement:"库存管理",
            userManagement:"用户系统",
            memberManagement:"会员系统",
            marketingManage:"营销系统",
            financialManagement:"财务系统",
            commodityManagement:"商品系统",
            operationsManagement:'营运系统',
            procurementManagement:"采购管理",
            transactionManagement:"交易管理",
            systemManagement:"系统管理",
            systemStorage :"进销存系统"
        },
        left:{
            BasicInformationManagement:"基础信息管理",
            contractManagement:"合同管理",
            afterSalesManagement:"售后单管理",
            refundSlipManagement:"退款单管理",
            authorizeManage:"授权管理",
            roleManage:"功能角色管理",
            dataScopeManage:"数据角色管理",
            groupManage:"岗位管理",
            noticeManage:"公告管理",
            platformCommodity:"平台商品管理",
            dimensionManage:"维度管理",
            mealtypeOperate:"套餐类型管理",
            retailerManage:"零售商管理",
            supplierManage:"基础信息管理",
            couponManagePlatform:"优惠券管理",
            couponManageStore:"优惠券管理（店铺）",
            myProfile:"我的资料",
            todoItems:"待办事项",
            accountList2B:"2B账号列表",
            accountList2C:"2C账号列表",
            managementSMS:'短信推送管理',
            configurationSMS:'短信推送配置',
            levelManagement:"等级管理",
            storeManagement:"店铺管理",
            offLineStore:"线下门店",
            supplyStore:"供应商店",
            businessAddressManagement:"商圈地址管理",
            businessCircleManagement:"商圈管理",
            supplierManagement:"供应商管理",
            authorizedCertificationManage:"授权认证管理",
            authorizedCertification:"授权认证（荣耀）",
            authorizedCertificationSupplier:"授权认证（供应商/神码）",
            fileManagement:"文件履历查询",
            fileHistory:"文件履历",
            basicConfiguration:'基础配置',
            invoiceConfiguration:"发票配置",
            paymentConfiguration :"支付配置",
            fundAccountManagement:'供应商资金账户列表',
            fundAccountList:'资金账户列表',
            clientFundManagement:'零售商在账资金管理',
            ICBCAccount :'工行账户信息查询',
            incentiveManagement:'激励管理',
            balanceFundsAccount:'在账资金余额查询',
            platformProductsManagement:'平台商品管理',
            supplierProductManagement:'供应商商品管理',
            storeGoodsSelect:"店铺商品查询",
            storeGoods:'店铺商品',
            commodityBaseManagement:'商品基础信息管理',
            productCategoriesManagement :"商品分类管理",
            propertyConfigurationManagement:"属性配置管理",
            propertyConfiguration :'属性配置',
            classificationRelationshipMaintenance:'分类和属性关系维护',
            SPUCommodityOperations :'商品上下架管理',
            SPUCommodityManagement:"商品上下架管理",
            smallProgramCommodityRackQuery:'小程序商品上下架查询',
            commodityOperation:'商品增值服务营运',
            announcementManagement :'公告管理',
            orderApproval:'进货申请审核',
            purchaseOrdeRmanagement:'零售商采购单管理',
            outOfManagement:'出入库查询',
            warehousingManagement:'入库单查询',
            outLibraryManagement:'出库单查询',
            storeAllocationInquiry:'门店调拨查询',
            inventoryManagement:'库存管理',
            inventoryInquiry:'库存查询',
            queryCode:'串码查询',
            stockSnapshot:'库存快照查询',
            serialRecords:'串码出入库记录',
            storeOrderManagement:'零售订单查询',
            vendorOrderManagement:'供应商销售单管理',
            refundManagement:'退款单管理',
            orderPushMonitoring:'订单推送监控',
            pushMonitoringConfiguration:'推送监控配置',
            couponManagement:'优惠券管理',
            marketingActivities:"营销活动",
            dimensionManagement:'维度管理',
            internationalInformationManagement:'国际化信息管理',
            lookupManagement:'Lookup管理',
            myImportExport:'我的导入导出',
            exportQuery:'导出查询',
            importQuery:'导入查询',
            importConfiguration:'导入配置',
            exportConfiguration:'导出配置',
            scheduledTasks:'定时任务',
            taskConfiguration:'任务配置',
            taskLogQuery:'任务日志查询',
            templateConfiguration:'模板配置',
            commodityAdvertisingManagement:"广告位管理",
            smallProgramGateway:"网关配置",
            serviceOpenAddress:"服务开放地址",
            refundRecordQuery:"交易流水查询",
            orderRefundRecord:"零售订单退款记录查询",
            orderManagement:"门店预约单管理",
            aftersalesManagement:'售后单管理',
            activityManagement:"活动管理",
        }
    },
    //用户管理
    user:{
        mydata:{
            account:"账号",
            userType:"用户类型",
            name:"姓名",
            contactPhone:"联系电话" ,
            email:"电子邮箱" ,
            QQ:"QQ",
            wechat:"微信"
        },
        retailerNews:{
            mydata:"我的资料",
            status:"状态",
            retailerCodes:"零售商代码",
            retailerName:"零售商名称",
            retailerAccount:"零售商账号",
            businessLicenseCode:"营业执照编码",
            province:"省份",
            city:"城市",
        },
        todo:{
            retailerCertificationApplication:"零售商认证审核",
            retailerRequestGoods:"零售商进货审核",
            storeRegistrationApplication:"门店认证审核",
            applicationStoreOccupancy:"建店资质审核",
            China:"中国",
            all:'全部',
            pendingReview:'待审核'
        },
        accountB:{
            accountUuid:"关联UP/W3账号",
            name:"姓名",
            phone:"联系人电话",
            code:"用户主体",
            subjectName:"主体名称",
            post:"岗位",
            country:"国家",
            province:"省份",
            city:"城市",
            zone:"地区",
            contactAddress:"详细地址",
            status:"状态",
            accountListInformation:"账号列表信息"
        },
        accountC:{
            userId:'用户ID',
            type:'用户类型',
            employeeNumber:'账号',
            displayname:'联系人姓名',
            phone:'联系人手机号',
            uuid:'加密账号信息',
            departmentNumber:'部门编号',
            departmentName:'部门名称',
            departmentNameEn:'部门英文名称',
            displayNameEn:'英文姓名',
            email:'联系人邮箱',
            lastUpdateDate:'最后登录时间',
            creationDate:'创建时间',
            employeetype:'第三方用户类型',
            appTYPE:'来源应用',
            reservationInformation:"预约信息",
            shippingAddressInformation:"收货地址信息",
            invoiceInformation:"发票信息",

            consigneeName:'收货人',
            consigneePhone:'收货人电话',
            consigneeCountryCode:'收货国家',
            consigneeProvinceCode:'收货省份',
            consigneeCityCode:'收货城市',
            consigneeDistrictCode:'收货区',
            consigneeDetail:'详细收货地址',
            isDefault:'是否默认',
            beUserName:"预约人",
            beUserPhone:"电话",
            provinceId:"收货省份",
            cityId:"收货城市",
            regionId:"收获区县",
            address:"详细收货地址",

            billType:'发票类型',
            invoiceTitle:'发票抬头',
            invoiceTitleType:'发票抬头类型',
            taxNum:'纳税识别号',
            isOpenTicket:'是否默认开票',

            userName:'预约人',
            detailQuery:"明细查询",

        }
    }
}


// WEBPACK FOOTER //
// ./src/locale/zh-CN.js